<template>
  <div>
    <b-card header="tabla"
            header-bg-variant="primary"
            header-text-variant="white">
      <b-form @submit.prevent="searchFilter">
        <b-container fluid>
          <b-row>
            <b-col cols="12" md>
              <b-form-input placeholder="Número de cédula o pasaporte"  v-model="filter_identification_number"/>
            </b-col>
            <b-col class="mt-2 mt-md-0" cols="12" md>
              <b-form-input placeholder="Filtrar por número de control" v-model="filter_control_number"/>
            </b-col>
            <b-col class="mt-2 mt-lg-0" cols="12" lg="3" md="6">
              <v-select placeholder="Tipo" 
                        v-model="filter_type"
                        :options="typeOptions"/>
            </b-col>
          </b-row>
          <b-row class="mt-2 mt-lg-4">
            <b-col class="mt-2 mt-lg-0" cols="12" lg="3" md>
              <b-button block style="min-width: initial !important; padding: initial !important" type="submit"
                        variant="secondary">Buscar
              </b-button>
            </b-col>
          </b-row>
        </b-container>
      </b-form>
    </b-card>
    <b-table :fields="fields"
             :items="payments_simplified"
             bordered
             details-td-class="text-center"
             hover
             stacked="lg"
             striped
             table-class="mb-0 mt-4 bg-white"
             thead-class="text-white"
             thead-tr-class="bg-primary"
    >
      <template v-slot:cell(actions)="data">
        <router-link
          :to="{ name: 'ViewPayment', params: { id: data.item.id }}"
          class="btn btn-secondary"
        >Detalles
        </router-link>
      </template>

      <template v-slot:cell(monto)="data">
        {{ data.item.monto | formatAmount('USD') }}
      </template>

      <template v-slot:cell(status)="data">
        <circle-status type='payment' :status="data.item.status"/>
      </template>
    </b-table>

    <b-pagination-nav
      v-if="payments_pagination && payments_pagination.meta"
      class="mt-4"
      hide-goto-end-buttons
      :value="payments_pagination.meta.current_page"
      :number-of-pages="payments_pagination.meta.last_page"
      :base-url="queryStringBase"
    />

    <payment-details
      v-if="id"
      :id="id"
      :visible="showPaymentDetails"
      @hide="onHidePaymentDetails"/>
  </div>
</template>

<script>
  import VSelect from 'vue-select';
  import PaymentDetails from "../../../components/PaymentDetails";
  import CircleStatus from "../../../components/CircleStatus";
  import { OPEN_LOADER, CLOSE_LOADER } from '@/store/modules/ui/types';
  import { mapState, mapActions, mapMutations, mapGetters } from 'vuex';
  export default {
    name: 'PaymentList',
    components: { CircleStatus, PaymentDetails, VSelect },
    props: ['id'],
    data() {
      return {
        filter_type: '',
        filter_identification_number: '',
        filter_control_number: '',
        typeOptions: [
            { label: 'Boleta',    value:1 },
            { label: 'Process',   value:2 },
            { label: 'Delivery',  value:3 },
        ],
        showPaymentDetails: false,
        fields: [
          { key: 'name', label: 'Nombre', tdClass: 'align-middle text-center', thClass: 'border-0' },
          { key: 'identification_number', label: 'No. Documento', tdClass: 'align-middle text-center', thClass: 'border-0' },
          { key: 'control_number', label: 'No. de Control', tdClass: 'align-middle text-center', thClass: 'border-0' },
          { key: 'type', label: 'Tipo', tdClass: 'align-middle text-center', thClass: 'border-0' },
          { key: 'monto', label: 'Monto', tdClass: 'align-middle text-center', thClass: 'border-0' },
          { key: 'status', label: 'Estado del pago', tdClass: 'align-middle text-center', thClass: 'border-0' },
          { key: 'source', label: 'Origen', tdClass: 'align-middle text-center', thClass: 'border-0' },
          { key: 'actions', label: '', thClass: 'border-0' }
        ],
        queryStringBase: '?page='
      }
    },
    computed: {
      ...mapState('payments', ['payments', 'payments_pagination']),
      ...mapGetters({payments_simplified: 'payments/payments_simplified'}),
    },
    methods: {
      ...mapMutations('ui', [OPEN_LOADER, CLOSE_LOADER]),
      ...mapActions('payments', ['doGetPayments']),
      onHidePaymentDetails() {
        this.$router.push({ name: 'PaymentsList' });
      },
      searchFilter() {
          let queryString = {};
          if (this.filter_identification_number) {
            queryString.identification_number = this.filter_identification_number;
          }
          if (this.filter_control_number) {
            queryString.control_number = this.filter_control_number;
          }
          if (this.filter_type) {
            queryString.type_id = this.filter_type.value;
          }
          /*
            TODO: el resto de filtros
          */
          this.$router.replace({ name: "PaymentsList", query: queryString });
          this.getPayments();
      },
      setFilters() {
        let queryString = '';
        if (this.$route.query.identification_number){
          this.filter_identification_number = this.$route.query.identification_number;
          queryString = '?identification_number=' + this.$route.query.identification_number;
        }
        if (this.$route.query.control_number){
          this.filter_control_number = this.$route.query.control_number;
          if (queryString) {
            queryString += '&';
          }
          else {
            queryString += '?';
          }
          queryString += 'control_number=' + this.$route.query.control_number;
        }
        if (this.$route.query.type_id){
          let typeO = this.typeOptions.filter(s => s.value === parseInt(this.$route.query.type_id))[0]
          this.filter_type = typeO.label;
          if (queryString) {
            queryString += '&';
          }
          else {
            queryString += '?';
          }
          queryString += 'type_id=' + this.$route.query.type_id;
        }
        /*
          TODO: aquí van el resto de filtros, antes de la paginacion
        */

        // Para baseUrl de los links de la paginacion
        if (queryString){
          this.queryStringBase = queryString + '&page='
        }
        else {
          this.queryStringBase = '?page='
        }

        if (this.$route.query.page){
          if (queryString) {
            queryString += '&';
          }
          else {
            queryString += '?';
          }
          queryString += 'page=' + this.$route.query.page;
        }

        return queryString;
      },
      getPayments(){
        let $vm = this;
        $vm.$store.commit('ui/' + OPEN_LOADER);
        let queryString = this.setFilters();
        $vm.doGetPayments(queryString).finally(() => {
          $vm.$store.commit('ui/' + CLOSE_LOADER); 
        });
      }
    },
    created() {
      this.getPayments();
    },
    watch: {
      id: {
        handler: function (newVal, oldVal) {
          this.showPaymentDetails = newVal !== undefined && newVal !== null && newVal !== oldVal;
        },
        immediate: true
      }
    }
  }
</script>

<style lang="scss" scoped>

</style>
